import { useState } from 'react'
import { ClipboardIcon, CheckIcon, CodeBracketIcon } from '@heroicons/react/24/outline'

export default function EmbedCodeDisplay({ apiKey, embedCode }) {
  const [copied, setCopied] = useState(false)

  const code = embedCode || (apiKey
    ? `<script src="${window.location.origin}/embed.js" data-api-key="${apiKey}"></script>`
    : '<script src="/embed.js" data-api-key="YOUR_API_KEY"></script>')

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement('textarea')
      textarea.value = code
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <div className="bg-slate-900 rounded-xl overflow-hidden">
      <div className="flex items-center justify-between px-5 py-3 border-b border-slate-700/50">
        <div className="flex items-center space-x-2">
          <CodeBracketIcon className="h-4 w-4 text-slate-400" />
          <div>
            <h4 className="text-sm font-semibold text-white">Embed Code</h4>
            <p className="text-xs text-slate-400 mt-0.5">
              Add this before &lt;/body&gt; in your HTML
            </p>
          </div>
        </div>
        <button
          onClick={handleCopy}
          className={`flex items-center space-x-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
            copied
              ? 'bg-emerald-500 text-white'
              : 'bg-white/10 text-white hover:bg-white/20'
          }`}
        >
          {copied ? (
            <>
              <CheckIcon className="h-3.5 w-3.5" />
              <span>Copied!</span>
            </>
          ) : (
            <>
              <ClipboardIcon className="h-3.5 w-3.5" />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
      <div className="px-5 py-4">
        <pre className="text-emerald-400 text-xs font-mono overflow-x-auto whitespace-pre-wrap break-all leading-relaxed">
          {code}
        </pre>
      </div>
    </div>
  )
}
